import clsx from 'clsx';

import { useTutorialStore } from '@event/store/useTutorialStore';
import Close from '@popup/components/Close';
import PopupTitle from '@popup/components/PopupTitle';
import Tip from '@popup/components/Tip';
import Button from '@ui/components/Button';
import useClientStore from '@utils/hooks/useClientStore';

interface TutorialLegendProps {
  onSubmit: () => void | undefined;
  textHeadingCounter: string;
  textHeading: string;
  textBubble: string;
  className?: string;
}

const TutorialLegend = ({
  onSubmit,
  textHeadingCounter,
  textHeading,
  textBubble,
  className,
}: TutorialLegendProps) => {
  const tutorialStore = useClientStore(useTutorialStore, (state) => state);
  const isTutorialEventTimeSlots =
    tutorialStore?.tutorialStep === 'eventTimeSlots' &&
    tutorialStore?.isTutorialActive;

  return (
    <div
      className={clsx(
        'group/notificationFull absolute z-20 flex w-full max-w-[360px] flex-wrap items-center justify-center rounded-[40px] shadow-popup transition-all duration-300 motion-reduce:transition-none',
        className,
      )}
    >
      <div className="relative flex h-[270px] w-full justify-center overflow-hidden rounded-t-[40px] bg-brand-primary-200 py-6 md:p-6">
        <PopupTitle
          text={textHeading}
          textHeadingCounter={textHeadingCounter}
          className="mt-6 max-w-[340px] text-center"
        />
        <Tip text={textBubble} isTutorial={true} />
        <Close onClick={() => tutorialStore?.setIsTutorialActive(false)} />
      </div>
      <div className="flex h-[96px] w-full items-center justify-center rounded-b-[40px] bg-brand-white-100 py-4">
        <Button className="w-48" size="big" onClick={onSubmit}>
          {isTutorialEventTimeSlots ? 'Začít vytvářet akci' : 'Pokračovat'}
        </Button>
      </div>
    </div>
  );
};

export default TutorialLegend;
